import script from "./selectSupplierComp.vue?vue&type=script&setup=true&lang=js"
export * from "./selectSupplierComp.vue?vue&type=script&setup=true&lang=js"

import "./selectSupplierComp.vue?vue&type=style&index=0&id=a8b1fdc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8b1fdc4"]])

export default __exports__